import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import { useWebsiteButton } from "../../customeHooks/useWebsiteButtons";
import { SingleFindEvent } from "../../redux/features/event/event.types";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../utils/constants";
import { getFindEventPriceText } from "../../utils/eventPricing";
import { formatDate } from "../../utils/helpers";
import { Icon } from "../icon/icon";
import { EventPosterImage } from "./eventPosterImage";

export const FindEventListItem = ({
  event,
  className = "",
}: {
  event: SingleFindEvent;
  className?: string;
}) => {
  const { goToEvent } = useWebsiteButton();

  const priceText = getFindEventPriceText(event);

  return (
    <Link
      className={`group flex items-start gap-4 ${className}`}
      to={goToEvent(event?.slug!)}
    >
      <div className="relative size-[69px] shrink-0 overflow-hidden rounded-[6px]">
        <EventPosterImage
          className="absolute inset-0 h-full w-full object-cover"
          alt={`${event.name} event poster`}
          image={event.image}
        />
      </div>

      <div className="flex min-w-0 flex-1 items-center gap-4 border-b-[0.5px] border-grey-200 pb-4 group-last:border-b-0">
        <div className="flex min-w-0 flex-1 flex-col gap-3">
          <div className="flex flex-col gap-[2px]">
            <p className="truncate font-onest text-base font-medium tracking-[-0.32px] text-ink">
              {event.name}
            </p>
            <p
              className="truncate font-onest text-[13px] text-[#7d7d7d]"
              style={{ fontFeatureSettings: '"ss01" 1' }}
            >
              {formatDate(event?.startDate, "ddd, MMM D", true)}
              {event?.startTime ? `, ${event.startTime}` : ""}
            </p>
          </div>

          <p
            className="font-onest text-sm text-[#7d7d7d]"
            style={{ fontFeatureSettings: '"ss01" 1' }}
          >
            {priceText}
          </p>
        </div>

        <Icon
          svg="chevron-right"
          width={20}
          height={20}
          className="shrink-0 text-grey-500 transition-transform duration-300 group-hover:translate-x-0.5"
        />
      </div>
    </Link>
  );
};

export const FindEventListItemLoader = () => {
  return (
    <div className="group flex items-start gap-4">
      <Skeleton
        highlightColor={SKELETON_HIGHLIGHT_COLOR}
        baseColor={SKELETON_BASE_COLOR}
        width={69}
        height={69}
        className="!rounded-[6px]"
      />

      <div className="flex flex-1 flex-col gap-3 border-b-[0.5px] border-grey-200 pb-4 group-last:border-b-0">
        <Skeleton
          highlightColor={SKELETON_HIGHLIGHT_COLOR}
          baseColor={SKELETON_BASE_COLOR}
          width={"70%"}
          height={20}
          className="rounded-xl"
        />

        <Skeleton
          highlightColor={SKELETON_HIGHLIGHT_COLOR}
          baseColor={SKELETON_BASE_COLOR}
          width={"40%"}
          height={16}
          className="rounded-xl"
        />
      </div>
    </div>
  );
};
